module.exports = __webpack_public_path__ + "static/media/spooky.1b007b4a.png";